export default function webShareSupported() {
  return (typeof navigator.share !== 'undefined')
}
